import { Field, useFormikContext } from "formik";
import { useState } from "react";

const CurrencyField = ({ name, placeholder }:{name:string; placeholder:string}) => {
  const { setFieldValue } = useFormikContext();
  const [displayValue, setDisplayValue] = useState("");

  const formatCurrency = (value:string) => {
    // Remove non-numeric characters
    const numericValue = value.replace(/\D/g, "");
    if (!numericValue) return "";

    // Format as currency
    return new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN",
      minimumFractionDigits: 0,
    })
      .format(Number(numericValue))
      .replace("NGN", "₦")
      .trim();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedValue = formatCurrency(e.target.value);
    setDisplayValue(formattedValue);
    setFieldValue(name, formattedValue.replace(/₦|,/g, ""));
  };

  return (
    <Field
      type="text"
      id={name}
      name={name}
      placeholder={placeholder}
      className="rounded-lg border border-gray-300 shadow px-4 py-3 w-full"
      value={displayValue}
      onChange={handleChange}
    />
  );
};

export default CurrencyField;